import { defineStore } from 'pinia'
import { ref } from 'vue'

export type ToastTone = 'info' | 'success' | 'warning' | 'danger'

export interface Toast {
  id: number
  tone: ToastTone
  /** i18n key */
  titleKey: string
  /** i18n key */
  messageKey?: string
  /** the server's own message, shown when `messageKey` has no translation */
  message?: string
  params?: Record<string, unknown>
  /** shown for server errors so support can trace the request */
  correlationId?: string
  durationMs: number
}

let seq = 0

export const useNotificationStore = defineStore('notifications', () => {
  const toasts = ref<Toast[]>([])
  const unreadCount = ref(0)

  function push(toast: Omit<Toast, 'id' | 'durationMs'> & { durationMs?: number }) {
    const id = ++seq
    toasts.value.push({ durationMs: toast.tone === 'danger' ? 10_000 : 5_000, ...toast, id })
    return id
  }

  function dismiss(id: number) {
    toasts.value = toasts.value.filter((t) => t.id !== id)
  }

  function setUnread(count: number) {
    unreadCount.value = count
  }

  function $reset() {
    toasts.value = []
    unreadCount.value = 0
  }

  return { toasts, unreadCount, push, dismiss, setUnread, $reset }
})
